import * as ko from 'knockout';

import { FeatureFlag, FeatureToggleService } from '@/features/feature-flags';
import { Instance as companyService } from '@/legacy/services/company';
import { Instance as userService } from '@/legacy/services/user';
import {
  identitySubmitted,
  identityVerified,
  isCompanyVerificationCompleted,
  isCompanyVerificationInProgress,
  isUnableToVerifyIdentity,
} from '@/utils/verification';

export const isPersonaEnabled = userService.UserId.mapAsync(
  (userId) => FeatureToggleService.isFeatureEnabled(FeatureFlag.SPR5_24_ONBOARDING_PERSONA, userId),
  { initialValue: null }
);

export const isPersonaActive = ko.pureComputed({
  read: () => {
    const isSubjectToPersonaOnboarding = companyService.profile()?.isSubjectToPersonaOnboarding();
    const isAccountingFirm = companyService.profile()?.isAccountingFirm();
    const hasAccountingFirmCompanyId = Boolean(companyService.profile()?.accountingFirmCompanyId());

    const isCompanySubjectToOnboarding =
      isSubjectToPersonaOnboarding && !isAccountingFirm && !hasAccountingFirmCompanyId;

    const isUserVerified = userService.profile()?.identityVerified();
    const isCompanyVerified = isCompanyVerificationCompleted();

    const isUserAndCompanyVerified = isUserVerified && isCompanyVerified;

    return isCompanySubjectToOnboarding && !isUserAndCompanyVerified;
  },
  deferEvaluation: true,
});

export async function getIsPartOfPersonaCohort(): Promise<boolean> {
  const featureFlagEnabled = await isPersonaEnabled.skipUntil((enabled) => enabled !== null);
  const enabledInBackend = isPersonaActive();
  return enabledInBackend || featureFlagEnabled;
}

export const isPersonaKycStep = ko.pureComputed(
  () =>
    (isCompanyVerificationCompleted() || isCompanyVerificationInProgress()) &&
    !(isUnableToVerifyIdentity() || identityVerified() || identitySubmitted())
);
